import { PROPERTIES } from './properties';
import { type TJsonQuery, type TJsonQueryKeys } from './types';

export function convertProperties(jsonQuery: TJsonQuery): TJsonQuery {
  const keys = Object.keys(jsonQuery) as TJsonQueryKeys[];

  const nextJsonQuery = keys.reduce((nextJq, currentKey) => {
    if (!!nextJq[currentKey] && PROPERTIES[currentKey]) {
      const { converter } = PROPERTIES[currentKey];
      if (converter) {
        return converter(nextJq);
      }
    }

    return nextJq;
  }, jsonQuery);

  return nextJsonQuery;
}
